export class DbCredModel{
  Id:number;
  DbName:string;
  Password:string;
  Host:string;
  ServiceName:string;
}
